<div class="dashboard--module-header">
    <h2 class="subheading-sm">Aged Debt <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<billing-aged-debt-chart class="module--main" [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData"></billing-aged-debt-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>


